import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {awsCropCalculatorURL, nodeExpressBeagleHash} from "../BeagleAws/beagle-aws";
import {plantCalculationLoadingPlaceholder} from "../CropStepper/PlantCatalogExample"
import BeagleBuildCardTable from "./BeagleBuildCardTable";
import CircularProgress from "@material-ui/core/CircularProgress";
import BeagleBuildSnackbar from "./BeagleBuildSnackbar";

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        maxWidth: 325,
    },
    rootNewCalc: {
        minWidth: 275,
        maxWidth: 325,
        backgroundColor: 'silver',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
        fontWeight: "bold",
    },
    pos: {
        marginBottom: 12,
    },
}));


export default function BeagleBuildCard(props) {
    const classes = useStyles();

    const [awsCropCalculation, setAwsCropCalculation] = React.useState({"cropKey": undefined, "awsStatus": "init"});
    const [awsNetworkCounter, setAwsNetworkCounter] = React.useState(0);

    const langPref = props.beagleLanguagePreference;
    const postCropKey = props.wizardCropKey;
    const postYieldGoal = Number(props.wizardYieldGoal);
    const postMathPref = props.beagleMathPreference === 'i';

    const switchWizardCropCalculation = props.switchWizardCropCalculation;


    useEffect(() => {

        let bh = awsNetworkCounter > 2 ? '' : nodeExpressBeagleHash;
        fetch(awsCropCalculatorURL,
            {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    // 'beagle': bh,
                    'x-api-key': bh,
                },
                body: JSON.stringify(
                    {
                        "cropKey": postCropKey,
                        "yieldGoal": postYieldGoal,
                        "isImperialMath": postMathPref
                    }
                )
            })
            .then(res => res.json())
            .then(data => {
                console.info(awsCropCalculatorURL);
                setAwsCropCalculation({...data, "awsStatus": "finished"});
                switchWizardCropCalculation({...data});
                setAwsNetworkCounter(awsNetworkCounter + 1);
            })
            .catch(() => {
                setAwsCropCalculation({"cropKey": undefined, "awsStatus": "unavailable"});
                setAwsNetworkCounter(-1);
            })
        // eslint-disable-next-line
    }, []);  // Pass empty array to only run once on mount.


    let isPlaceholderCard = false;
    if (awsNetworkCounter === 0 || awsCropCalculation['cropKey'] === undefined) {
        isPlaceholderCard = true;
    }

    return (
        <Card className={classes.root}>

            {
                isPlaceholderCard ? (

                        <CardContent>
                            <Typography component={'span'} className={classes.title} color="textSecondary" gutterBottom>

                                {awsNetworkCounter === 0 ?
                                    (
                                        <CircularProgress/>
                                    ) :
                                    ('network error')
                                }
                            </Typography>
                            <Typography variant="h4" component="h2">
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                            </Typography>
                            <Typography component={'span'}>
                                <BeagleBuildCardTable
                                    beagleLanguagePreference={props.beagleLanguagePreference}
                                    awsCropCalculation={plantCalculationLoadingPlaceholder}
                                    isPlaceholderCard={true}
                                />
                            </Typography>
                        </CardContent>
                    ) :

                    (
                        <CardContent>
                            <Typography component={'span'} className={classes.title} color="textSecondary" gutterBottom>
                                {awsCropCalculation.cropName[langPref]}
                            </Typography>
                            <Typography variant="h4" component="h2">
                                {awsCropCalculation.yieldGoal}
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                {awsCropCalculation.yieldUnit}
                            </Typography>
                            <Typography component={'span'}>
                                <BeagleBuildCardTable
                                    beagleLanguagePreference={props.beagleLanguagePreference}
                                    awsCropCalculation={awsCropCalculation}
                                    isPlaceholderCard={false}
                                />
                            </Typography>
                            {/*<h2>awsNetworkCounter={awsNetworkCounter}</h2>*/}
                        </CardContent>
                    )
            }

            <BeagleBuildSnackbar
                beagleLanguagePreference={props.beagleLanguagePreference}
                awsNetworkCounter={awsNetworkCounter}
            />

        </Card>
    );
}
